import { Dispatch } from 'redux';
import { AxiosResponse } from 'axios';
import { DispatchFunction, IOrganizationShortDetails, IActiveFilter, IOrganizationDetail } from '@app/models';
import { GET_ALL_ORGANIZATIONS, SET_ORGS_COUNT, GET_ORGANIZATION } from '@app/store/constants';
import { organizationsService } from '@app/services';
import { loadingData } from '@app/store/actions';

export function handleGetOrganizationsShortDetailsData(orderBy: string, asc: string, top: number, skip: number, isReset: boolean, filters?: IActiveFilter[]): DispatchFunction {
    return ((dispatch: Dispatch) => {
        if (isReset) {
            dispatch(loadingData(true));
            dispatch(setOrgsCount(0));
            dispatch(getAllOrganizationsShortDetails([]));
        }

        organizationsService.getOrganizationsShortDetails(orderBy, asc, top, skip, isReset, filters)
            .then((response: AxiosResponse) => {
                dispatch(getAllOrganizationsShortDetails(response.data.value));

                if (isReset) {
                    dispatch(setOrgsCount(response.data['@odata.count']));
                    dispatch(loadingData(false));
                }
                
            })
            .catch(() => {
                // TODO: Uncomment when we will set up dev variable
                // console.log(error);
                dispatch(loadingData(false));
            });
    });
}

export function handleGetOrganization(organizationId: string): DispatchFunction {
    return ((dispatch: Dispatch) => {
        organizationsService.getOrganization(organizationId)
            .then((response: AxiosResponse) => {
                dispatch(getOrganization(response.data));
            })
            .catch(() => {
                // TODO: Uncomment when we will set up dev variable
                // console.log(error);
            });
    });
}

export function getAllOrganizationsShortDetails(orgs: IOrganizationShortDetails[]) {
    return {
        payload: orgs,
        type: GET_ALL_ORGANIZATIONS
    };
}

export function setOrgsCount(count: number) {
    return {
        payload: count,
        type: SET_ORGS_COUNT
    };
}

export function getOrganization(organization: IOrganizationDetail) {
    return {
        payload: organization,
        type: GET_ORGANIZATION
    };
}
